import { Select } from '@ipfabric/ui-components/Select/Select';
import { prop } from '@ipfabric/utils/fp/prop';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import { useTableContextSelectors } from '../model/TableModel';

export const TableFilterPresets: FC = () => {
  const ctxProps = useTableContextSelectors({
    filterPresets: prop('filterPresets'),
    selectedFilterPreset: prop('selectedFilterPreset'),
    onSelectFilterPreset: prop('onSelectFilterPreset'),
  });
  const actionsMsg = useLocale().apiTable.actions;

  if (
    ctxProps.filterPresets.length === 0 ||
    ctxProps.selectedFilterPreset === undefined ||
    !ctxProps.onSelectFilterPreset
  ) {
    return null;
  }

  const options = ctxProps.filterPresets.map((preset) => ({
    label: preset.name,
    value: preset.id,
  }));

  return (
    <Select.Optional
      className='w-36'
      clearable
      dataTestId='table-filter-presets-select'
      options={options}
      value={ctxProps.selectedFilterPreset?.id ?? null}
      placeholder={actionsMsg.selectFilter}
      onChange={ctxProps.onSelectFilterPreset}
      size='small'
    />
  );
};
